import { OAuthModuleConfig } from 'angular-oauth2-oidc';
import { environment } from 'env/config';
import { uniq } from 'lodash';

//URLS of services that will send the bearer token

const conf = {
  resourceServer: {
    allowedUrls: uniq(Object.values(environment.domains)),
    //sendAccessToken: true,  // Primavera case, no noeed to send the access token
    sendAccessToken: environment.environment === 'local' ? true : false,
  },
};

export const authModuleConfig: OAuthModuleConfig = conf;
